import React, { Fragment } from 'react'

import ThemeMenuOne from '../../components/header/ThemeMenuOne'
import ThemeBannerOne from '../../components/theme-banner/ThemeBannerOne'
import MarqueSlider from '../../components/marque/MarqueSlider'
import BlockStyleOne from '../../components/block/BlockStyleOne'
import FeatureOne from '../../components/feature/FeatureOne'
import FeatureSliderOne from '../../components/feature-slider/FeatureSliderOne'
import DesignSliderOne from '../../components/feature-slider/DesignSliderOne'
import FeatureTwo from '../../components/feature/FeatureTwo'
import CounterOne from '../../components/counter/CounterOne'
import NewsletterOne from '../../components/call-to-action/NewsletterOne'
import FooterOne from '../../components/footer/FooterOne'
import CodamHomeRingGraphic from '../../components/codam/CodamHomeRingGraphic'

const ItSolution = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">

                <ThemeMenuOne />
                <ThemeBannerOne />
                <MarqueSlider />

                <section className="about-codam codam-home-intro position-relative pb-15">
                    <div className="container">
                        {/* 파비콘·원링 텍스트만: 컨테이너 전체폭에서 항상 중앙(모바일·태블릿·데스크톱 공통) */}
                        <div className="row gx-4 gx-xxl-5 codam-home-intro__ring-row">
                            <div className="col-12">
                                <div className="codam-home-intro__ring-band">
                                    <div className="codam-home-intro__ring-slot">
                                        <div className="logo-animated-block codam-home-intro__logo-ring">
                                            <div className="mark-icon">
                                                <img src={`${process.env.PUBLIC_URL}/assets/img/favicon.png`} alt="CODAM 파비콘" />
                                            </div>
                                            <div className="codam-home-intro__ring-layer" aria-hidden="true">
                                                <CodamHomeRingGraphic className="rotate-img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row gx-4 gx-lg-5 gx-xxl-5 gy-5 gy-xl-5 align-items-center align-items-xl-start justify-content-xl-center codam-home-intro__row">
                            <div className="col-12 col-xl-6 col-xxl-5 codam-home-intro__visual-col text-center">
                                <div className="codam-home-intro__visual-inner position-relative">
                                    <div
                                        className="about-img-wrapper codam-home-intro__img-wrap position-relative"
                                        data-aos="fade-right"
                                        data-aos-delay={100}
                                    >
                                        <img
                                            className="main-img"
                                            src={`${process.env.PUBLIC_URL}/assets/img/about/main_1.png?v=codamhome5`}
                                            alt="CODAM IT 솔루션 구축 현황"
                                        />
                                        <img className="shape-one" src="assets/img/shape/line-round-2a.svg" alt="배경 도형" />
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-12 col-xl-5 col-xxl-4 codam-home-intro__copy-col text-center text-xl-start"
                                data-aos="fade-left"
                                data-aos-delay={100}
                            >
                                <BlockStyleOne />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="our-services pt-80 pb-105 pt-lg-45 pb-lg-15">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 justify-content-lg-start justify-content-center">
                            <div className="col-xl-7 col-lg-8 col-md-10">
                                <div className="section-title codam-home-services-head text-center text-lg-start mb-55">
                                    <h2 className="sect-title mb-20" data-aos="fade-up">
                                        기업 문제 해결 중심의 <span className="codam-kr-nowrap-inline">IT 서비스</span>
                                    </h2>
                                    <p data-aos="fade-right" data-aos-delay={100}>단순 개발이 아닌, 기업의 비즈니스 목표와 운영 환경을 깊이 이해하고 실제 성과를 만들어내는 구축을 제공합니다.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row gx-4 gx-xxl-5">
                            <FeatureOne />
                        </div>
                    </div>
                </section>

                <section className="feature-work-area slick-nav blog-slick pt-90 pb-95 pt-lg-50 pb-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title text-center text-md-start mb-60">
                                    <h2 className="sect-title mb-25" data-aos="fade-up">주요 구축 사례</h2>
                                    <p data-aos="fade-up" data-aos-delay={100}>다양한 산업군의 기업 고객과 함께 완성한 실제 구축 프로젝트입니다.</p>
                                </div>
                            </div>
                        </div>
                        <div className="feature-slider-one">
                            <FeatureSliderOne />
                        </div>
                    </div>
                </section>

                <section className="feature-work-area codam-home-design-portfolio slick-nav blog-slick pt-90 pb-95 pt-lg-50 pb-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title text-center text-md-start mb-60">
                                    <h2 className="sect-title mb-25" data-aos="fade-up">
                                        코담 디자인 포트폴리오
                                    </h2>
                                    <p data-aos="fade-up" data-aos-delay={100}>
                                        캐릭터·IP, 산업 장비, 제품·패키지까지 브랜드 경험을 완성하는 디자인
                                        사례입니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="feature-slider-one">
                            <DesignSliderOne />
                        </div>
                    </div>
                </section>

                <section className="feature-two codam-feature-process pt-150 pb-105 pt-lg-85 pb-lg-70">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 justify-content-lg-start justify-content-center">
                            <div className="col-xl-7 col-lg-8 col-md-10">
                                <div className="section-title codam-feature-process__head text-lg-start text-center mb-75 mb-lg-80">
                                    <h2 className="sect-title mb-25">CODAM 프로젝트 진행 방식</h2>
                                    <p>요구사항 분석부터 배포, 운영 지원까지 체계적인 프로세스로 프로젝트를 완성합니다.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row gx-4 gx-xxl-5">
                            <FeatureTwo />
                        </div>
                    </div>
                    <img className="shape-one" src="assets/img/shape/line-round-1.svg" alt="" />
                </section>

                <CounterOne />

                <NewsletterOne />
                <FooterOne />
            </div>
        </Fragment>
    )
}

export default ItSolution
